import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  openMesh: cacheLs.get_open_mesh()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
